export default [
    {
        path: "/games/transfer/luck/:categoryId",
        name: "TransferLuck",
        component: resolve => require(["./TransferLuckV2.vue"], resolve)
    },
    {
        path: "/games/thunderclap/three/:categoryId",
        name: "ThunderclapThree",
        component: resolve => require(["./ThunderclapThree.vue"], resolve)
    }
];


// WEBPACK FOOTER //
// ./src/views/games/router.js